import { FeatureTourServiceImplFactory } from "../../core/impl/featureTourServiceImpl";
import { IGetFeatureToursParams } from "../driven/repositories/featureTourRepository";

type IFeatureTourService = ReturnType<typeof FeatureTourServiceImplFactory>;

export type IFeatureTourController = ReturnType<
  typeof FeatureTourControllerFactory
>;

export const FeatureTourControllerFactory = ({
  featureTourService,
}: {
  featureTourService: IFeatureTourService;
}) => {
  const getFeatureTours = async (params: IGetFeatureToursParams) => {
    return await featureTourService.getFeatureTours(params);
  };

  const completeFeatureTourStep = async (
    featureName: string,
    stepId: string,
    completedVia: string
  ) => {
    return await featureTourService.completeFeatureTourStep({
      featureName,
      stepId,
      completedVia,
    });
  };

  return {
    getFeatureTours,
    completeFeatureTourStep,
  };
};
